import { dashboard } from 'routes/paths';
import { GET_DASHBOARD, GET_DASHBOARD_API_CALLS_ADMIN, GET_API_VALIDITY_ADMIN, GET_API_VALIDITY_ADMIN_SECOND, GET_API_LOG } from 'store/actions/dashboard';

const initialState = {
  isAuthenticated: false,
  loader: false,
  dashboardProfile: {},
  dashboardApiCalls: {},
  dashboardValidity: {},
  dashboardValiditySecond: {},
  dashboardApiLog: {},

};

const getDashboard = (state, payload) => {
  const { callback } = payload;
  if (typeof callback === 'function') {
    callback(payload);
  }
  const stateObj = {
    ...state,
    isAuthenticated: true,
    dashboardProfile: payload?.data,
  };
  return stateObj;
};
const getDashboardApiCalls = (state, payload) => {
  const { callback } = payload;
  if (typeof callback === 'function') {
    callback(payload);
  }
  const stateObj = {
    ...state,
    isAuthenticated: true,
    dashboardApiCalls: payload?.data,
  };
  return stateObj;
};
const getDashboardValidityApi = (state, payload) => {
  const { callback } = payload;
  if (typeof callback === 'function') {
    callback(payload);
  }
  const stateObj = {
    ...state,
    isAuthenticated: true,
    dashboardValidity: payload?.data,
  };
  return stateObj;
};
const getDashboardValidityApiSecond = (state, payload) => {
  const { callback } = payload;
  if (typeof callback === 'function') {
    callback(payload);
  }
  const stateObj = {
    ...state,
    isAuthenticated: true,
    dashboardValiditySecond: payload?.data,
  };
  return stateObj;
};

const getDashboardApiLog = (state, payload) => {
  const { callback } = payload;
  if (typeof callback === 'function') {
    callback(payload);
  }
  const stateObj = {
    ...state,
    isAuthenticated: true,
    dashboardApiLog: payload?.data,
  };
  return stateObj;
};

const Dashboard = (state = initialState, { type, payload = null }) => {
  switch (type) {
    case GET_DASHBOARD:
      return getDashboard(state, payload);
    case GET_DASHBOARD_API_CALLS_ADMIN:
      return getDashboardApiCalls(state, payload);
    case GET_API_VALIDITY_ADMIN:
      return getDashboardValidityApi(state, payload);
    case GET_API_VALIDITY_ADMIN_SECOND:
      return getDashboardValidityApiSecond(state, payload);
    case GET_API_LOG:
      return getDashboardApiLog(state, payload);
    default:
      return state;
  };
}
export default Dashboard;
